jQuery(function ($) {
  const tickers = document.querySelectorAll('.ticker_number');

  if(tickers.length){
    tickers.forEach(ticker => {
      ticker.ticker = new tickerNumber(ticker);
    });
  }
});

// Ticker Class
class tickerNumber {
  constructor(el) {
    this.el = el;
    this.digitWraps = this.el.querySelectorAll('.ticker_number__digit_wrap');

    if(!this.digitWraps.length){
      return;
    }

    // Watch for the ticker to enter the viewport
    this.observer = new IntersectionObserver((entries, observer) => {
      this.intersectionObserver(entries, observer);
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 1
    });
    this.observer.observe(this.el);
  }

  intersectionObserver(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Loop over each digit, and animate to the set value
        this.digitWraps.forEach(digitWrap => {
          const digitWrapInner = digitWrap.querySelector('.ticker_number__digit');
          const setValue = digitWrap.querySelector('.ticker_number__digit_val.set_value');
          
          if(!setValue){
            return;
          }

          digitWrapInner.style.setProperty('--top-pos', (setValue.innerHTML * -10) + '%');
        });

        observer.unobserve(entry.target);
      }
    });
  }
}